import styled from 'styled-components';

type Props = {
  $selected?: boolean;
  $voted?: boolean;
};

export const Wrapper = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid
    ${({ theme, $selected }) => ($selected ? theme.colors.green6 : theme.colors.black4)};
  background: ${({ theme, $voted }) => ($voted ? 'transparent' : theme.colors.white)};

  .ant-rate {
    color: ${({ theme, $voted }) => ($voted ? theme.colors.black6 : theme.colors.green6)};
  }

  &:hover {
    border: ${({ theme, $selected, $voted }) =>
      !$selected && !$voted && `1px solid ${theme.colors.black5}`};
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    max-width: 800px;
    padding: 16px 20px;
  }
`;

export const TeacherNameWrapper = styled.span<Props>`
  color: ${({ theme, $voted }) => ($voted ? theme.colors.black6 : theme.colors.black9)};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const DateWrapper = styled.span<Props>`
  color: ${({ theme, $voted }) => ($voted ? theme.colors.black6 : theme.colors.black9)};
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`;

export const RateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    flex-direction: row;
    gap: 16px;
  }
`;

export const CommentsTitleWrapper = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
`;

export const RateTitleWrapper = styled.span`
  display: flex;
  flex: 1;
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
`;
